const SMALL_WIDTH = 354;
const SMALL_HEIGHT = 193;
const LARGE_WIDTH = 708;
const LARGE_HEIGHT = 386;

const journalPages = {
  items: [
    {
      id: 0,
      title: 'journal-article--0--title',
      meta: {
        html_url: 'https://www.getmyboat.com/journal/lifestyle/the-best-meals-snacks-for-a-boat-day/',
        slug: 'the-best-meals-snacks-for-a-boat-day',
        first_published_at: '2023-06-09T12:00:00.00Z',
        locale: 'en',
      },
      header_image: {
        sizes: [
          {
            url: 'https://cms-media.getmyboat.com/production/images/boat-rentals-review-miami-florida-azimut-30170.width-621.jpg',
            width: SMALL_WIDTH,
            height: SMALL_HEIGHT,
          },
          {
            url: 'https://cms-media.getmyboat.com/production/images/boat-rentals-review-miami-florida-azimut-3017.width-1024.jpg',
            width: LARGE_WIDTH,
            height: LARGE_HEIGHT,
          },
        ],
      },
    },
    {
      id: 1,
      title: 'journal-article--1--title',
      meta: {
        html_url: 'https://www.getmyboat.com/journal/experiences/the-15-most-popular-reasons-for-boat-rentals-in-2023/',
        slug: 'the-15-most-popular-reasons-for-boat-rentals-in-2023',
        first_published_at: '2023-11-07T12:00:00.00Z',
        locale: 'en',
      },
      header_image: {
        sizes: [
          {
            url: 'https://cms-media.getmyboat.com/production/images/most-popular-boat-rental-reasons-2-6947.width-546.jpg',
            width: SMALL_WIDTH,
            height: SMALL_HEIGHT,
          },
          {
            url: 'https://cms-media.getmyboat.com/production/images/most-popular-boat-rental-reasons-2-6947.width-900.jpg',
            width: LARGE_WIDTH,
            height: LARGE_HEIGHT,
          },
        ],
      },
    },
    {
      id: 2,
      title: 'journal-article--2--title',
      meta: {
        html_url: 'https://www.getmyboat.com/journal/experiences/make-a-splash-with-your-special-someone-top-5-date-ideas-on-the-water/',
        slug: 'make-a-splash-with-your-special-someone-top-5-date-ideas-on-the-water',
        first_published_at: '2021-08-18T12:00:00.00Z',
        locale: 'en',
      },
      header_image: {
        sizes: [
          {
            url: 'https://cms-media.getmyboat.com/production/images/-processed_4.width-472.jpg',
            width: SMALL_WIDTH,
            height: SMALL_HEIGHT,
          },
          {
            url: 'https://cms-media.getmyboat.com/production/images/-processed_4.width-778.jpg',
            width: LARGE_WIDTH,
            height: LARGE_HEIGHT,
          },
        ],
      },
    },
    {
      id: 3,
      title: 'journal-article--3--title',
      meta: {
        html_url: 'https://www.getmyboat.com/journal/lifestyle/your-ultimate-summer-boating-playlist-25-of-the-best-songs-for-the-waves/',
        slug: 'your-ultimate-summer-boating-playlist-25-of-the-best-songs-for-the-waves',
        first_published_at: '2023-08-16T12:00:00.00Z',
        locale: 'en',
      },
      header_image: {
        sizes: [
          {
            url: 'https://cms-media.getmyboat.com/production/images/boating-playlist-4174.width-698.jpg',
            width: SMALL_WIDTH,
            height: SMALL_HEIGHT,
          },
          {
            url: 'https://cms-media.getmyboat.com/production/images/boating-playlist-4174.width-1150.jpg',
            width: LARGE_WIDTH,
            height: LARGE_HEIGHT,
          },
        ],
      },
    },
    {
      id: 4,
      title: 'journal-article--4--title',
      meta: {
        html_url: 'https://www.getmyboat.com/journal/experiences/the-ultimate-guide-to-weddings-elopements-at-sea/',
        slug: 'the-ultimate-guide-to-weddings-elopements-at-sea',
        first_published_at: '2022-01-13T12:00:00.00Z',
        locale: 'en',
      },
      header_image: {
        sizes: [
          {
            url: 'https://cms-media.getmyboat.com/production/images/wedding_and_elopement_header_image.width-388.jpg',
            width: SMALL_WIDTH,
            height: SMALL_HEIGHT,
          },
          {
            url: 'https://cms-media.getmyboat.com/production/images/wedding_and_elopement_header_image.width-640.jpg',
            width: LARGE_WIDTH,
            height: LARGE_HEIGHT,
          },
        ],
      },
    },
    {
      id: 5,
      title: 'journal-article--5--title',
      meta: {
        html_url: 'https://www.getmyboat.com/journal/lifestyle/the-best-boating-playlists-for-your-boat-day/',
        slug: 'the-best-boating-playlists-for-your-boat-day',
        first_published_at: '2022-09-07T12:00:00.00Z',
        locale: 'en',
      },
      header_image: {
        sizes: [
          {
            url: 'https://cms-media.getmyboat.com/production/images/boat-rentals-review-glenbrook-ne.width-414.jpg',
            width: SMALL_WIDTH,
            height: SMALL_HEIGHT,
          },
          {
            url: 'https://cms-media.getmyboat.com/production/images/boat-rentals-review-glenbrook-ne.width-1011.jpg',
            width: LARGE_WIDTH,
            height: LARGE_HEIGHT,
          },
        ],
      },
    },
  ],
};

export default journalPages;
